var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingMode = function SvgShoppingMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M446-80q-15 0-30-6t-27-18L103-390q-12-12-17.5-26.5T80-446t5.5-30 17.5-27l352-353q11-11 26-17.5t31-6.5h287q33 0 56.5 23.5T879-800v287q0 16-6 30.5T856-457L503-104q-12 12-27 18t-30 6m0-80 353-354v-286H513L160-446zm253-480q25 0 42.5-17.5T759-700t-17.5-42.5T699-760t-42.5 17.5T639-700t17.5 42.5T699-640M480-480"
  })));
};
export default SvgShoppingMode;